import Helper from '@ember/component/helper';
import { FormType, formTypeLabel } from 'cio/utils/forms';

export default Helper.helper(function ([formType]: [FormType]) {
  return formTypeLabel(formType);
});
